//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var id = 1;
export default {
  name: 'DragTool',
  inject: ['fcx'],
  props: ['dragBtn', 'children', 'unique', 'type'],
  data: function data() {
    return {
      typeList: ['leaveFrom', 'overtimeFrom', 'outFrom', 'refillFrom', 'tripFrom', 'contractPayment', 'contractRenewal', 'contractExpenditure', 'issueInvoice', 'voidedInvoice'],
      id: this.unique || id++,
      state: this.fcx
    };
  },
  methods: {
    active: function active() {
      if (this.state.active === this.id) return;
      this.state.active = this.id;
      this.$emit('active');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.state = {};
  }
};